import {RETINA_MEDIA_QUERY} from 'styles/Utilities';

export const JOIN_ORGANIZATION_SCREEN = 'JOIN_ORGANIZATION_SCREEN';
export const CALL_TO_ACTION_SCREEN = 'CALL_TO_ACTION_SCREEN';
export const ENTRY_INFO_SCREEN = 'ENTRY_INFO_SCREEN';
export const MOL_BIO_INFO_SCREEN = 'MOL_BIO_INFO_SCREEN';
export const ROLE_INFO_SCREEN = 'ROLE_INFO_SCREEN';
export const ROLE_INFO_SCREEN_WITHOUT_FLOW = 'ROLE_INFO_SCREEN_WITHOUT_FLOW';

export const SIGNUP_FLOW_V2_AFFILIATION_SCREEN = 'SIGNUP_FLOW_V2_AFFILIATION_SCREEN';
export const SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN = 'SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN';
export const SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN = 'SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN';
export const SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN = 'SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN';
export const SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN = 'SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN';

export const TERMINAL_SCREENS = [CALL_TO_ACTION_SCREEN, SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN];

export const ALL_SCREENS = [
  JOIN_ORGANIZATION_SCREEN,
  CALL_TO_ACTION_SCREEN,
  ENTRY_INFO_SCREEN,
  MOL_BIO_INFO_SCREEN,
  ROLE_INFO_SCREEN,
  ROLE_INFO_SCREEN_WITHOUT_FLOW,
  SIGNUP_FLOW_V2_AFFILIATION_SCREEN,
  SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN,
  SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN,
  SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN,
  SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN,
] as const;

export type NewUserFlowScreen = (typeof ALL_SCREENS)[number];

export const LAB_NOTEBOOK_FLOW = 'LAB_NOTEBOOK_FLOW';
export const MOL_BIO_FLOW = 'MOL_BIO_FLOW';

export type NewUserFlow = typeof LAB_NOTEBOOK_FLOW | typeof MOL_BIO_FLOW;

export const FLOWS: Record<NewUserFlow, Array<NewUserFlowScreen>> = {
  [LAB_NOTEBOOK_FLOW]: [ENTRY_INFO_SCREEN],
  [MOL_BIO_FLOW]: [MOL_BIO_INFO_SCREEN],
};

export const SCREEN_TO_ANALYTICS_NAME: {[screen: string]: string} = {
  JOIN_ORGANIZATION_SCREEN: 'join_organization',
  CALL_TO_ACTION_SCREEN: 'choose_cta',
  ENTRY_INFO_SCREEN: 'notebook_overview',
  MOL_BIO_INFO_SCREEN: 'molecular_biology_overview',
  SIGNUP_FLOW_V2_AFFILIATION_SCREEN: 'affiliation',
  SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN: 'academic_role_info',
  SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN: 'industry_role_info',
  SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN: 'join_organization',
  SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN: 'molbio_or_notebook',
};

export const DEFAULT_BACKGROUND_IMAGE_URL_1X = '/static/img/new-user-flow/blur-product-1x.png';
export const NOTEBOOK_BACKGROUND_IMAGE_URL_1X = '/static/img/new-user-flow/blur-notebook-1x.png';
export const MOLBIO_BACKGROUND_IMAGE_URL_1X = '/static/img/new-user-flow/blur-molbio-1x.png';
export const DEFAULT_BACKGROUND_IMAGE_URL_2X = '/static/img/new-user-flow/blur-product-2x.png';
export const NOTEBOOK_BACKGROUND_IMAGE_URL_2X = '/static/img/new-user-flow/blur-notebook-2x.png';
export const MOLBIO_BACKGROUND_IMAGE_URL_2X = '/static/img/new-user-flow/blur-molbio-2x.png';

export const RETINA_IMAGES = [
  DEFAULT_BACKGROUND_IMAGE_URL_2X,
  NOTEBOOK_BACKGROUND_IMAGE_URL_2X,
  MOLBIO_BACKGROUND_IMAGE_URL_2X,
];
export const NON_RETINA_IMAGES = [
  DEFAULT_BACKGROUND_IMAGE_URL_1X,
  NOTEBOOK_BACKGROUND_IMAGE_URL_1X,
  MOLBIO_BACKGROUND_IMAGE_URL_1X,
];

export function getNewUserFlowViewImages(): Array<string> {
  return window.matchMedia(RETINA_MEDIA_QUERY).matches ? RETINA_IMAGES : NON_RETINA_IMAGES;
}
